<template>
    <v-navigation-drawer stateless value="true">
        <search/>
        <v-list v-if="getOrdersInProgress.length > 0" class="v-list--booking">
            <v-list-item
                :key="item.id"
                active-class="active"
                v-for="item in getOrdersInProgress"
                @click="editOrder(item.id)"
                :class="`v-list--booking_state v-list--booking_state--${item.state} ${$route.params.orderId === item.id ? 'active' : ''}`">
                <v-list-item-title>Заказ №{{ item.id }}</v-list-item-title>
            </v-list-item>
        </v-list>
        <empty v-else/>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Search from '../Components/Search'
    import Empty from '../../../../components/Loader/Empty'

    export default {
        name: 'orderNavigationInProgress',
        components: {
            Search,
            Empty
        },
        methods: {
            editOrder (id) {
                this.$router.push({
                    name: 'editOrderForInProgress',
                    params: { orderId: id }
                })
            }
        },
        computed: mapGetters([
            'getOrdersInProgress'
        ])
    }
</script>
